// ============================================================================
// SEED / DEMO GROUP DISCUSSIONS
// Demo posts + comments shown inside the demo (seed-group-*) groups so they look
// active. Read-only. Same pattern as the other seed files — removable via the
// admin "Hide demo content" toggle (demo groups only appear when demo is shown).
// Keyed by seed group id.
// ============================================================================

export const SEED_DISCUSSIONS = {
  'seed-group-1': [
    {
      id: 'seed-post-1a', isSeed: true, authorName: 'John Smith',
      title: 'Deal flow picking up in Q3?',
      content: 'Seeing a real uptick in mid-market tech mandates this quarter. Anyone else watching sponsors come back to the table after a quiet first half?',
      createdAt: '2026-06-18T14:00:00Z', likeCount: 14, likes: [], commentCount: 2,
      seedComments: [
        { authorName: 'Sarah Johnson', content: 'Yes — our PE coverage team is busier than it’s been in a year. Mostly add-ons though, not new platforms.' },
        { authorName: 'Michael Chen', content: 'Same on the corp-dev side. Valuations finally feel reasonable again.' },
      ],
    },
    {
      id: 'seed-post-1b', isSeed: true, authorName: 'Jessica Lee',
      title: 'Standardizing our LBO template — recommendations?',
      content: 'Onboarding a few analysts and want one clean LBO template for the team. What references does the group swear by?',
      createdAt: '2026-06-20T16:30:00Z', likeCount: 9, likes: [], commentCount: 1,
      seedComments: [
        { authorName: 'David Kim', content: 'A clean internal template beats anything off the shelf — but Wall Street Prep is a solid starting point.' },
      ],
    },
  ],
  'seed-group-2': [
    {
      id: 'seed-post-2a', isSeed: true, authorName: 'Sarah Johnson',
      title: 'How is everyone thinking about exit timing?',
      content: 'Given the rate environment, are you extending holds where the thesis has runway, or pushing to exit into strength?',
      createdAt: '2026-06-19T13:00:00Z', likeCount: 11, likes: [], commentCount: 1,
      seedComments: [
        { authorName: 'Robert Wilson', content: 'Extending where there’s still a value-creation lever to pull. Forcing an exit into a soft market rarely ends well.' },
      ],
    },
  ],
  'seed-group-3': [
    {
      id: 'seed-post-3a', isSeed: true, authorName: 'David Kim',
      title: 'Reps & warranties insurance on sub-$50M deals?',
      content: 'Increasingly seeing RWI on smaller transactions. At what enterprise value does it stop making sense for you?',
      createdAt: '2026-06-21T11:00:00Z', likeCount: 7, likes: [], commentCount: 2,
      seedComments: [
        { authorName: 'Emily Rodriguez', content: 'We’ve placed it as low as ~$25M EV when the buyer insists — premiums have come down a lot.' },
        { authorName: 'Michael Chen', content: 'Agreed, it’s almost standard now even on lower-middle-market deals.' },
      ],
    },
  ],
};

export const getSeedDiscussions = (groupId) => SEED_DISCUSSIONS[groupId] || [];
